import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { IndustriesContract } from '@packages/contracts';

import { INDUSTRY_QUERY_KEY } from '../query-keys';

type IndustryRootsRoute = typeof IndustriesContract['listRoots'];
type IndustryRootsResponse = ClientInferResponseBody<IndustryRootsRoute, 200>['result']['industries'];
export type IndustryRootsQueryOptions = UseQueryOptions<
	IndustryRootsRoute,
	ClientArgs,
	IndustryRootsResponse
>;

export const createIndustryRootsQueryOptions = (): IndustryRootsQueryOptions => ({
	queryKey: INDUSTRY_QUERY_KEY.roots,

	retry: (failureCount: number, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: response => response.body.result.industries,
});
